
import GenderIcon from './gender-icon'
export default
  name: 'combined-results'
  components: {GenderIcon}
  props:
    heats: Array
    fields: Array
    races: Object
  data: ->
    currentPage: 1
    perPage: 50
    totalRows: 1
    filter: null
    filterOn: ['name']
  mounted: ->
    @totalRows = @heats.length
  methods:
    onFiltered: (filteredItems) ->
      @totalRows = filteredItems.length
      @currentPage = 1

